import { Component, OnInit } from '@angular/core';
import { CourseFilterComponent } from 'src/app/utils/course-filter/course-filter.component';
import {forkJoin, map, switchMap, tap, zip} from "rxjs";
import {AuthorizationServiceProvider} from "../../../../auth_profile/services/authorization-service.provider";
import {NativeServiceApiProvider} from "../../../../services/native-api-provider.service";
import * as LessonsV3 from "../../../model/v3/lessons";

@Component({
    selector: 'app-progress-card-list',
    templateUrl: './progress-card-list.component.html',
    styleUrls: ['./progress-card-list.component.scss'],
    standalone: false
})
export class ProgressCardListComponent implements OnInit {

  CourseFilterComponent = CourseFilterComponent
  studentId: number
  schoolId: number
  contextMap = new Map<string, LessonsV3.ColCourseContext>()
  constructor(private authService: AuthorizationServiceProvider,
              private provider: NativeServiceApiProvider) { }

  ngOnInit(): void {
    this.authService.getAuthDetailsService().pipe(
      switchMap(api => zip(api.getSelfStudentId(), api.getSelfSchoolId())),
      tap(([studentId, schoolId]) => {
        this.studentId = studentId
        this.schoolId = schoolId
      }),
      switchMap(_ => this.getProgressMap())
    ).subscribe()
  }

  private getProgressMap() {
    const sources = CourseFilterComponent.getFilters()
      .slice(1)
      .map(lang => lang.filter)
      .map((langCode) => this.provider.colV3().pipe(
        switchMap((api) => api.getCourseContexts(this.schoolId, this.studentId, langCode)),
        map((contexts) => {
          if (!contexts || contexts.length === 0) {
            return null;
          }
          const sorted = contexts.slice().sort((a, b) =>
            (a.course?.code ?? '').localeCompare(b.course?.code ?? '', undefined, {numeric: true})
          );
          return sorted[sorted.length - 1];
        }),
        tap((context) => {
          if (context != null) {
            this.contextMap.set(langCode, context);
          }
        })
      ));

    return forkJoin(sources)
  }

  hasResults() {
    if(this.contextMap.size == 0) return false
    return Array.from(this.contextMap.values()).filter(value => value != null).length > 0;
  }

  getContextList() {
    return Array.from(this.contextMap)
  }
}
